import { Flex, Heading, Text } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export const PlotHeader = (props: {
  title: ReactNode;
  subtitle: string;
  children: ReactNode;
}) => {
  return (
    <Flex justify="between" align="center" gap="2" width="100%">
      <Flex direction="column" minHeight="50px" width="100%">
        <Flex justify="between">
          <Heading size="4">{props.title}</Heading>
          {props.children}
        </Flex>

        <Text color={RADIX.COLOR.NEUTRAL} truncate>
          {props.subtitle}
        </Text>
      </Flex>
    </Flex>
  );
};
